import { Link } from '@superops/ui-design-system';
import React from 'react';
import { FormattedMessage } from 'react-intl';

export function InvoiceListCell({ cell }) {
  return (
    <Link
      removeUnderline
      onClick={() => cell.column.actions.click(cell.row.original)}
    >
      <FormattedMessage
        id="invoice.partialPayments.invoice.count"
        values={{ count: String(cell.value ?? '0') }}
      />
    </Link>
  );
}
